<template>
    <div :style="styleObj" v-html="txt">
    </div>
</template>

<script>
export default {
    name:'l-txt',
    props:{
        txt:{
            type:String,
            default:'请输入描述文案'
        },
        css:{
            type: String,
            default: ''
        }
    },
    computed: {
        styleObj () {
            let obj = {}
            if (this.css) {
                try {
                   obj = JSON.parse(this.css) 
                } catch (error) {
                    
                }
            }
            return obj
        }
    }
}
</script>
<style lang="less">
</style>